import { ConfigurationParameters } from "neurotec-megamatcherid-management-client";

export enum APIsActionType {
    SetUpAdminAPIs,
    SetUpAdjudicatorAPIs
}

export interface SetUpAdminAPIs {
    type: APIsActionType.SetUpAdminAPIs,
    configuration: ConfigurationParameters
}

export interface SetUpAdjudicatorAPIs {
    type: APIsActionType.SetUpAdjudicatorAPIs,
    configuration: ConfigurationParameters
}

export type APIsActions = SetUpAdminAPIs | SetUpAdjudicatorAPIs